import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { RoleUserDTO } from '../../../core/models/role.model';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';


export interface DeleteDialogData {
  role: RoleUserDTO;
  clientName?: string;
}

@Component({
  selector: 'app-role-delete-dialog',
  imports: [
    MatIconModule,
    MatChipsModule
],
  templateUrl: './role-delete-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./role-delete-dialog.component.scss']
})
export class RoleDeleteDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RoleDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteDialogData
  ) { }

  /**
   * Annule la suppression
   */
  onCancel(): void {
    this.dialogRef.close(false);
  }

  /**
   * Confirme la suppression
   */
  onConfirm(): void {
    this.dialogRef.close(true);
  }

  /**
   * Obtient le type de rôle
   */
  getRoleType(): string {
    return this.data.role.clientRole ? 'Client' : 'Realm';
  }
}